import BaseAPIService from './baseAPI';

export interface BrandGuidelineData {
  id: string;
  brand_name: string;
  brand_voice?: string;
  tone_of_voice?: string;
  keywords?: string[];
  hashtags?: string[];
  writing_style?: string;
  content_restrictions?: Record<string, unknown>;
  compliance_rules?: string;
  is_active?: boolean;
}

export interface BrandGuidelinesResponse {
  success: boolean;
  has_guidelines: boolean;
  guideline?: BrandGuidelineData;
  message?: string;
}

export interface BrandGuidelineSavePayload {
  brand_name: string;
  brand_voice?: string;
  tone_of_voice?: string;
  keywords?: string[];
  hashtags?: string[];
  writing_style?: string;
  content_restrictions?: Record<string, unknown>;
  compliance_rules?: string;
  is_active?: boolean;
}

export interface BrandCheckContentResponse {
  success: boolean;
  passed: boolean;
  issues: string[];
  suggestions: string[];
  score: number;
}

class BrandAPIService extends BaseAPIService {
  async getGuidelines(): Promise<BrandGuidelinesResponse> {
    return this.get<BrandGuidelinesResponse>('/brand/guidelines');
  }

  async saveGuidelines(payload: BrandGuidelineSavePayload): Promise<BrandGuidelineData> {
    return this.post<BrandGuidelineData>('/brand/guidelines', payload);
  }

  async checkContent(content: string): Promise<BrandCheckContentResponse> {
    return this.post<BrandCheckContentResponse>('/brand/check-content', { content });
  }
}

export const brandAPI = new BrandAPIService();
export default brandAPI;
